export const zones = ["home", "map", "registry", "events", "configurations"];
export const tags = ["tag1", "tag2", "tag3", "tag4", "tag5"];
export const tenants = ["TOP/DELOITTE", "TOP/DELOITTE/PT/LISBOA", "TOP/DELOITTE/PT/PORTO", "TOP/DELOITTE/PT/VISEU", "TOP/DELOITTE/PT/COIMBRA"];
export const booleans = ["True", "False"];
export const periodicity = ["Daily", "Hourly", "Monthly"];
export const period = ["Hour", "Day", "Month"];
export const primitiveTypes = ["Int", "Float", "String", "Bool"];
export const locationTypes = ["Above", "Below"];
export const urgency = ["INFO", "LOW", "MEDIUM", "HIGH", "CRITICAL"];
export const privacy = ["Private", "Public"];

// This is old, its being used in the old configurations 
export const types = new Map();
types.set(1, 'Label');
types.set(2, 'TextBox');
types.set(3, 'SingleSelect');
types.set(4, 'MultiSelect');
types.set(5, 'Checkbox');
types.set(6, 'Custom');
types.set(7, 'Textarea');
types.set(8, 'Button');
types.set(9, 'Table');
types.set(10, 'Divider');
types.set(11, 'Switch');

export const fieldTypes = {
    label: 'Label',
    textBox: 'TextBox',
    singleSelect: 'SingleSelect',
    multiSelect: 'MultiSelect',
    checkbox: 'Checkbox',
    custom: 'Custom',
    textarea: 'Textarea',
    button: 'Button',
    table: 'Table',
    divider: 'Divider',
    switch: 'Switch',
    number: 'Number',
    password: 'Password',
};